import { render, staticRenderFns } from "./vin.vue?vue&type=template&id=0162120d&scoped=true"
import script from "./vin.vue?vue&type=script&lang=js"
export * from "./vin.vue?vue&type=script&lang=js"
import style0 from "./vin.vue?vue&type=style&index=0&id=0162120d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0162120d",
  null
  
)

export default component.exports